// @flow
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

import CompatibilityUtil from '../CompatibilityUtil';
import {TAGS} from '../../constants/AppPicker/appPickerConstants';

class HelpPopoverUtil {
	feedbackResponses: Object;
	fullQuestionList: Array<Object>;
	questionEngText: Object;
	selectedQuestion: string;
	closeAutoDownloadPopover: Function;
	closeGetHelpPopover: Function;
	updateHelpPopoverConfig: Function;
	openGetHelpPopover: Function;
	openAutoDownloadPopover: Function;
	updateHelpPopoverConfig: Function;
	setCallback: Function;
	setFaqListIsAvailable: Function;

	constructor() {
		this.feedbackResponses = [];
		this.fullQuestionList = [];
		this.questionEngText = {};
		this.closeAutoDownloadPopover = () => {};
		this.closeGetHelpPopover = () => {};
		this.openAutoDownloadPopover = () => {};
		this.updateHelpPopoverConfig = () => {};
		this.setFaqListIsAvailable = () => {};
	}

	getCompatibilityTags(products: string[] = [], forceIncompatible?: boolean) {
		if (forceIncompatible) {
			return [TAGS.COMPATIBILITY.INCOMPATIBLE];
		}
		let isCompatible = false;
		let isPreviousVersion = false;
		let isIncompatible = false;
		const contentTags = [];
		products.forEach((sapCode) => {
			if (!CompatibilityUtil.isAppSupported(sapCode)) {
				if (CompatibilityUtil.isAnyOlderVersionSupported(sapCode)) {
					isPreviousVersion = true;
				}
				else {
					isIncompatible = true;
				}
			}
			else {
				if (sapCode !== 'KCCC') {
					isCompatible = true;
				}
				else if (!CompatibilityUtil.isCCDSupported()) {
					isPreviousVersion = true;
				}
				else {
					isCompatible = true;
				}
			}
		});
		if (isPreviousVersion) {
			contentTags.push(TAGS.COMPATIBILITY.OLDER_VERSION_COMPATIBLE);
		}
		if (isIncompatible) {
			contentTags.push(TAGS.COMPATIBILITY.INCOMPATIBLE);
		}
		if (isCompatible) {
			contentTags.push(TAGS.COMPATIBILITY.COMPATIBLE);
		}
		return contentTags;
	}

	getInstallWorkflowTag(hasThor: ?boolean) {
		if (hasThor) {
			if (CompatibilityUtil.isCCDSupported()) {
				return [TAGS.INSTALL_WORKFLOW.CCD_PRESENT];
			}
			return [TAGS.INSTALL_WORKFLOW.THOR_PRESENT];
		}
		return [TAGS.INSTALL_WORKFLOW.KAIZEN];
	}
}

export default new HelpPopoverUtil();
